import { agreementStatusLabels, agreementTypeLabels } from '../agreements.constants';
import type { AgreementDataRow } from '../models/agreement-sheet.model';

/**
 * Adapts a single Get-Agreements API record (loosely typed) into {@link AgreementDataRow}.
 */
export function mapAgreementApiRecordToDataRow(record: unknown): AgreementDataRow {
    const r = record as Record<string, unknown>;
    const statusCode = Number(r.status);
    const statusLabel =
        Number.isInteger(statusCode) && agreementStatusLabels[statusCode]
            ? agreementStatusLabels[statusCode]
            : String(r.status ?? '');

    const agreementTypeCode = Number(r.agreementType);
    const agreementTypeLabel =
        Number.isInteger(agreementTypeCode) && agreementTypeLabels[agreementTypeCode] !== undefined
            ? agreementTypeLabels[agreementTypeCode]
            : Number.isFinite(agreementTypeCode)
              ? String(agreementTypeCode)
              : '';

    const movementDetails = r.movementDetails as Record<string, unknown> | undefined;
    const averageTransportCost = movementDetails?.averageTransportCost as
        | Record<string, unknown>
        | undefined;
    const co2Emissions = movementDetails?.co2Emissions as Record<string, unknown> | undefined;
    const transportCurrency = averageTransportCost?.currency as Record<string, unknown> | undefined;
    const co2Uom = co2Emissions?.uom as Record<string, unknown> | undefined;
    const flags = r.flags as Record<string, unknown> | undefined;
    const originOrganisation = r.originOrganisation as Record<string, unknown> | undefined;
    const originFacility = r.originFacility as Record<string, unknown> | undefined;
    const destinationOrganisation = r.destinationOrganisation as
        | Record<string, unknown>
        | undefined;
    const destinationFacility = r.destinationFacility as Record<string, unknown> | undefined;

    return {
        agreementNumber: String(r.agreementNumber ?? ''),
        status: statusLabel,
        yourReference: String(r.yourReference ?? ''),
        agreementType: agreementTypeLabel,
        description: String(r.description ?? ''),
        startDate: String(r.startDate ?? ''),
        expiryDate: String(r.expiryDate ?? ''),
        isCod: Boolean(flags?.isCOD),
        originOrganisation: String(originOrganisation?.name ?? ''),
        originPartnerId: String(originOrganisation?.partnerId ?? ''),
        originFacility: String(originFacility?.name ?? ''),
        originFacilityCode: String(originFacility?.code ?? ''),
        destinationOrganisation: String(destinationOrganisation?.name ?? ''),
        destinationPartnerId: String(destinationOrganisation?.partnerId ?? ''),
        destinationFacility: String(destinationFacility?.name ?? ''),
        destinationFacilityCode: String(destinationFacility?.code ?? ''),
        averageTransportCost: Number.isFinite(Number(averageTransportCost?.amount))
            ? Number(averageTransportCost.amount)
            : '',
        transportCurrency: String(transportCurrency?.code ?? ''),
        co2Emissions: Number.isFinite(Number(co2Emissions?.value))
            ? Number(co2Emissions.value)
            : '',
        co2Uom: String(co2Uom?.symbol ?? ''),
        isUnverified: Boolean(r.isUnverified),
    };
}
